export default async (file, stripDataUrl = true) => {
  const reader = new FileReader();

  const result = await new Promise(resolve => {
    reader.addEventListener('load', () => resolve(reader.result), {
      once: true,
    });
    reader.readAsDataURL(file);
  });

  if (stripDataUrl) {
    // Wait for the file to be read then split the string and take the second item which will remove the data:*/*;base64, per https://developer.mozilla.org/en-US/docs/Web/API/FileReader/readAsDataURL
    return result.split(',').pop();
  }

  return result;
};



// WEBPACK FOOTER //
// ./src/common/Helpers/convertFileToBase64.js